import * as crypto from 'crypto';
import { STORAGE_OWNER_HASH_DOMAIN } from '@cf-shared/storage-object-path';

// The client's half of the storage owner token (#5016). The server computes the
// same value from the authenticated uid and refuses any key whose token is not
// the caller's — see `design-docs/image-uploads.md`, "Who may delete or
// overwrite an object".
//
// SYNCHRONOUS on purpose, using the same browserified `crypto` that
// `ImageService.generateImageId` already uses. The async Web Crypto helper
// beside `author-identity-hash.ts` would be the obvious thing to copy and is
// the wrong choice here: `buildImageVariantKey` is called inside the
// variant-ladder loop, so making it async would ripple through the whole upload
// path for no gain.
//
// The domain constant is shared with the server so the two can never drift. It
// is deliberately NOT the exercise author domain: a published exercise carries
// its author's identity hash in a document many people can read, so reusing it
// would let anybody holding one work out that author's image prefix.
export function computeStorageOwnerTokenSync(uid: string): string {
  return crypto.createHash('sha256').update(STORAGE_OWNER_HASH_DOMAIN + uid).digest('hex');
}
